<template>
  <BaseDialog
    v-model="showAnnouncementDialog"
    :title="announcementDetails.title"
  >
    <template #information>
      <div class="pt-4">
        <span v-html="announcementDetails.description" />
      </div>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/BaseDialog.vue";
import { bus } from "@/main";
export default {
  components: { BaseDialog },
  props: {
    id: {
      type: Number,
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showAnnouncementDialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  data() {
    return {
      announcementDetails: {
        title: "Test",
      },
    };
  },
  watch: {
    value(val) {
      if (val) {
        this.getAnnouncementObject(this.id);
      }
    },
  },
  methods: {
    getAnnouncementObject(id) {
      bus.$emit("showLoader", true);
      this.$api.announcement
        .getAnnouncementView(id)
        .then((res) => {
          this.announcementDetails = res.data;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
  },
};
</script>

<style></style>
